module.exports = __webpack_public_path__ + "202408221624/img/8.e3908263.png";